module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/terms-b314041a5efe221ad83797ee95eabb83.jpg";